import { initFavoriteBasket } from "@js/parts/globals/favorites/functions/initFavoriteBasket";

$(document).ready(function() {
	initFavoriteBasket();
});
